'use client';

import React, { FC } from 'react';
import useFeature from '@/hooks/useFeature';
import { FeatureFlag } from '@/core/featureFlags';
import UsablenetAccessibilityLink from './UsablenetAccessibilityLink';
import UserwayAccessibilityLink from './UserwayAccessibilityLink';

interface AccessibilityLinkProps {
  enableAccessibilityLabel: string;
  disableAccessibilityLabel: string;
  className?: string;
}

const AccessibilityLink: FC<AccessibilityLinkProps> = ({
  enableAccessibilityLabel,
  disableAccessibilityLabel,
  className,
}) => {
  const isUserwayEnabled =
    process.env.NEXT_PUBLIC_USERWAY_ACCOUNT &&
    // eslint-disable-next-line react-hooks/rules-of-hooks -- Safe to conditionally call hook here as ENV var is consistent across app lifecycle
    useFeature(FeatureFlag.PRINCE_157_ENABLE_USERWAY_WIDGET);

  const commonProps = {
    enableAccessibilityLabel,
    disableAccessibilityLabel,
    className,
  };

  return isUserwayEnabled ? (
    <UserwayAccessibilityLink {...commonProps} />
  ) : (
    <UsablenetAccessibilityLink {...commonProps} />
  );
};

export default AccessibilityLink;
